const JosenAlbumsStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/78cIWBHZWVSETsK6W8woCO?si=SJEtNsRqRDu5Puca_pmGQw" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-pmyQBVOlP5adNY0v-Z1ZAHg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Plugg On Drill Street</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/4b2TRYgQEPotdtn4kXqJMa?si=P8vYR6wLR92qFQtnsYs27w" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-yeecJqYMZKJS9AoH-qFszYw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Drill La Drill</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/6cELva8mV9GxqP9RBvpib5?si=2oHMR2l0TN6AHbeHuPM-Sg" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-CarFD2NJ42gNIEXz-cJk87Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>To Drill a Mockingbird</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/3ESAyTEpZgyV4ZgckodjE2?si=rYmvU-G0SpCTNfGeJWgpZA" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-baeecbf1-68e2-4126-99e9-8c1b2fbc5afa-0-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>WELCOME2JOSENWORLD</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://soundcloud.com/liljosen/sets/josen-friends" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000501146109-2wwpq1-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Josen & Friends</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/liljosen/sets/blue-faces-pretty-faces" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000330383667-0o36vi-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Blue Faces & Pretty Faces</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/liljosen/sets/3d-josen-x-vision4k" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000295782873-a9rrfs-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>3D</strong><br/>
                (prod. Vision4k)
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default JosenAlbumsStatic;